import 'css-chunksrc/client/pages/costProfilesPage/sidebar/costProfiles/costProfile/styles.scss';export default {
  "costProfile": "_costProfile_jns47_1",
  "contextualMenu": "_contextualMenu_jns47_7",
  "centered": "_centered_jns47_11",
  "icon": "_icon_jns47_15",
  "col": "_col_jns47_23",
  "name": "_name_jns47_28",
  "cost": "_cost_jns47_1",
  "removeIcon": "_removeIcon_jns47_45"
};